import Agende from "../";

const routes = [
    { name: "AgendeList", path: "/agende", component: Agende.AgendeList, meta: { title: "agende.lblTitle" } },
    { name: "AgendaView", path: "/agende/view/:id", component: Agende.AgendaView, meta: { title: "agende.lblTitle" } },
    { name: "AgendaEdito", path: "/agende/edit/:id", component: Agende.AgendaEdit, meta: { title: "agende.lblTitle" } },
];

export default routes;
